import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AccessibilityNewIcon(props: IconProps) {
    return <Icon {...props} iconKey={"accessibility_new"}/>
}
